import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, HallListActionId, exhibitionActionId, hallMasterListActionId, toastError, toastSuccess } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getStallMasterList_action, deleteStallMaster_action } from "../../../../actions/admin_module_action/master_action/stall_master_action";
import Footer from "../../../../common_components/Footer";


class StallMasterList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            exhibitionList: [],
            hallMasterList: [],
            stallMasterList: [],
            exhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
            hallID: '',
            stallName: '',
            deleteID: '',
            loginAccesslist: []
        }

        this.getFillList = this.getFillList.bind(this)
        this.record = this.record.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.deleteStallMaster = this.deleteStallMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.getstallMasterList = this.getstallMasterList.bind(this)
        this.onExhibitionChange = this.onExhibitionChange.bind(this)
    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '');
        this.getFillList(HallListActionId, '', '', '', '', '');
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })

        this.getstallMasterList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === exhibitionActionId) {
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            exhibitionList: data.data
                        })

                    }
                }
                if (data.error != 1) {
                    // country list
                    if (actionID === HallListActionId) {
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            hallMasterList: data.data
                        })

                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '73');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '73');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '73');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }


    record(list) {
        return (
            <table class="table sticky-table text-nowrap table-bordered mb-0">
                <thead class="table-light">

                    <tr>
                        {/* <th className="text-center">Role ID</th> */}
                        {/* <th className="text-center">From Date</th>
                        <th className="text-center">To Date</th>
                    <th className="text-center">Country</th> */}
                        <th className="text-center" style={{ width: '50px' }}>Sr no.</th>
                        <th >Exhibition Name</th>
                        <th className="text-center"> Stall Name</th>
                        <th className="text-center">Hall Name</th>
                        <th style={{ width: '60px' }} className="text-center"></th>
                        <th style={{ width: '60px' }} className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    <td className="text-center" style={{ width: '50px' }}>{i + 1}</td>
                                    {/* <td className="text-center">{data.RoleID}</td> */}
                                    {/* <td className="text-center">{moment(data.ExhibitionDateFrom).format('L')}</td>
                                    <td className="text-center">{moment(data.ExhibitionDateTo).format('L')}</td>
                                <td className="text-center">{this.state.countryList.map(id => (parseInt(id.Code) == data.CountryID ? id.Description : null))}</td> */}
                                    <td >{data.ExhibitionName}</td>
                                    <td className="text-center">{data.StallName}</td>
                                    <td className="text-center">{data.HallName}</td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            disabled={!this.getUpdateAccess()}
                                            onClick={(e) => this.handleUpdate(data.StallId)}
                                        >
                                            Update
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            disabled={!this.getDeleteAccess()}
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={(e) => this.onDelete(data.StallId)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    getstallMasterList() {
        this.setState({ isLoading: true })
        const { stallName, hallID, exhibitionID } = this.state
        this.props.getStallMasterList_action(exhibitionID, hallID, stallName)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0])
                    this.setState({ stallMasterList: data.data[0] })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { exhibitionID, hallName } = this.state
        this.setState({
            exhibitionID: '',
            stallName: '',
            hallID: ''
        })
        setTimeout(() => {
            this.getstallMasterList()
        }, 100);
    }

    handleAdd() {
        this.props.navigate('/stallMasterAU', { state: { is_add: true, } })
    }

    handleUpdate(id) {
        this.props.navigate('/stallMasterAU', { state: { is_update: true, stallID: id } })
    }

    deleteStallMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteStallMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getstallMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    onExhibitionChange(value) {
        const { exhibitionID } = this.state
        this.setState({ exhibitionID: value })
        this.getFillList(hallMasterListActionId, value, '', '', '', '');
    }

    updateItem(item) {
        const { stallMasterList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = stallMasterList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(stallMasterList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }

    render() {
        const { isOpen, isLoading, exhibitionID, currentPage, stallMasterList, stallName, hallID, hallMasterList, exhibitionList, hallName } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = stallMasterList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(stallMasterList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Stall List</h6>
                            </div>
                        </div>
                        {/* <div className="app-content with-dr-container com-height"> */}
                        <div className="admin-top-space p-2">
                            {/* <div className="row "> */}
                            {
                                JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                <div className="row m-0">
                                    <div className="col-md-3">
                                        <label>Exhibition</label>
                                        <select className="form-control"
                                            value={exhibitionID}
                                            onChange={(e) => this.onExhibitionChange(e.target.value)}  >
                                            <option value={''}>Select</option>
                                            {
                                                exhibitionList.length > 0 && exhibitionList.map(data => (
                                                    <option value={data.ExhibitionID} key={data.ExhibitionID}>{data.ExhibitionName}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>Hall Name</label>
                                        <select className="form-control"
                                            value={hallID}
                                            onChange={(e) => this.setState({ hallID: e.target.value })}  >
                                            <option value={''}>Select</option>
                                            {
                                                hallMasterList.length > 0 && hallMasterList.map(data => (
                                                    <option value={data.HallId} key={data.HallId}>{data.HallName}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>Stall Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={stallName}
                                            onChange={(e) => this.setState({ stallName: e.target.value, })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        {
                                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                            <div
                                                className="mb-1 mt-2"
                                                role="group"
                                                aria-label="Basic example"
                                                style={{ float: "right" }}
                                            >
                                                <label></label>
                                                <button type="button" className="btn btn-aqua"
                                                    onClick={e => this.getstallMasterList()}
                                                >
                                                    Search
                                                </button>
                                                <button type="button" className="btn btn-aqua mx-2"
                                                    disabled={!this.getWriteAccess()}
                                                    onClick={e => this.handleAdd()}
                                                >
                                                    Add
                                                </button>
                                                <button type="button" className="btn btn-gray"
                                                    onClick={e => this.clearSearch()}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        }
                                    </div>
                                    {/* <div class="">
                                    <label for="validationCustom03">Total Exhibition Area<span style={{ color: 'red' }}>*</span></label>
                                    <input value={totalExhibitionArea} onChange={(e) => this.setState({ totalExhibitionArea: parseInt(e.target.value) })} type="number" class="form-control" placeholder="" />
                                </div> */}
                                </div>
                            }
                            {/* </div> */}
                            < div className="row mt-3" >

                            </div>
                            <div class="table-responsive px-1 sticky-table-wrapper mx-2">
                                {this.record(currentRecords)}
                            </div>
                            <div className="mt-2 float-left trp ms-2 px-1">
                                {
                                    stallMasterList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                                <div className="table-record-pages">
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content text-center p-4">
                                <h5 className="fw-semibold text-danger mb-2">Are you sure?</h5>
                                <p className="mb-4">Do you really want to delete this record?</p>
                                <div className="d-flex justify-content-center gap-3">
                                    <button
                                        type="button"
                                        className="btn btn-danger px-4"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.deleteStallMaster(this.state.deleteID)}
                                    >
                                        Yes
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-gray px-4"
                                        data-bs-dismiss="modal"
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getStallMasterList_action, deleteStallMaster_action })(StallMasterList));